import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'browser-support-screen',
  templateUrl: './browser-support-screen.component.html',
  styleUrls: ['./browser-support-screen.component.scss'],
})
export class BrowserSupportScreenComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
